import { useMutation } from '@apollo/client';
import { UpdateProductInventoryMutation, UpdateProductInventoryMutationVariables } from '_graphql/mutation/__generated__/graphql';
import { UPDATE_PRODUCT_INVENTORY } from '_graphql/mutation/products';

export const useUpdateProductInventory = (
  variables?: UpdateProductInventoryMutationVariables
) => {
  const [updateProductInventory, { ...rest }] = useMutation<
    UpdateProductInventoryMutation,
    UpdateProductInventoryMutationVariables
  >(UPDATE_PRODUCT_INVENTORY, {
    variables,
    refetchQueries: ['GetProduct'],
  });
  return {
    ...rest,
    updateProductInventory,
  };
};
